import $api from "@/zapi-frontend/shared/api/axios";

export const caseBriefDocumentPath = (caseBriefId: number, documentId: number) =>
  `/chat/create-project-chat/case-brief/${caseBriefId}/documents/${documentId}`;

export const projectDocumentPath = (projectId: number, documentId: number) =>
  `/projects/${projectId}/documents/${documentId}`;

// Opens a Vault entry in a new tab: a web link at its address, a file at the short-lived link `filePath`
// returns. The tab opens before that request, because a browser blocks a tab opened after an await.
export async function openVaultDocument(document: { webUrl?: string | null }, filePath: string | null): Promise<void> {
  if (document.webUrl) {
    window.open(document.webUrl, "_blank", "noopener,noreferrer");
    return;
  }
  if (!filePath) throw new Error("The file has no link to open it with");
  const tab = window.open("", "_blank");
  try {
    const response = await $api.get<{ data: { url: string } }>(filePath);
    const url = response.data.data.url;
    if (!tab) {
      window.open(url, "_blank", "noopener,noreferrer");
      return;
    }
    tab.opener = null;
    tab.location.href = url;
  } catch (error) {
    tab?.close();
    throw error;
  }
}
